import useMarketingStatus from './use-marketing-status';

export default { useMarketingStatus };

export { useMarketingStatus };
